export const IDWELL_TO_IDWELL_FILE_POLL_CONFIG = {
  attemptsToIncreaseDelay: 10,
  longDelayMs: 10000,
  maxAttempts: 25,
  shortDelayMs: 5000,
}
